import { render, staticRenderFns } from "./PriceDetailsUser.vue?vue&type=template&id=6cb25560&"
import script from "./PriceDetailsUser.vue?vue&type=script&lang=js&"
export * from "./PriceDetailsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports